const INTERNAL_NETWORKS = ['10.81', '10.82', '10.151'];
const VPN_ADDRESSES = ['198.90.15.65', '198.90.14.204'];

export function isInternalIP(subjectIP: string): boolean {
	const isVPN = Boolean(VPN_ADDRESSES.find((ip) => subjectIP === ip));
	const isInternal = Boolean(INTERNAL_NETWORKS.some((network) => subjectIP.startsWith(network)));
	return isVPN || isInternal;
}
